import 'react';
import DigitalRetailOverlayCTA from '../DigitalRetailOverlayCTA/DigitalRetailOverlayCTA.js';
import { jsx } from 'react/jsx-runtime';
function DealCardDeepLink(_ref) {
  let {
    vehicle,
    onSDPError,
    uiContext = 'dealPanel',
    ...rest
  } = _ref;
  return /*#__PURE__*/jsx(DigitalRetailOverlayCTA, {
    listedPrice: vehicle.sellingPrice,
    listing: vehicle,
    onError: onSDPError,
    uiContext: uiContext,
    ...rest
  });
}
export { DealCardDeepLink as default };
